import { render, staticRenderFns } from "./commissionDetail.vue?vue&type=template&id=38f36559&scoped=true"
import script from "./commissionDetail.vue?vue&type=script&lang=js"
export * from "./commissionDetail.vue?vue&type=script&lang=js"
import style0 from "./commissionDetail.vue?vue&type=style&index=0&id=38f36559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f36559",
  null
  
)

export default component.exports